/**
 * Internet.Booking.Machine (Inbooma) web UI
 *
 * Leave the following imports in their order:
 * They are required for bootstrapping the app
 */
import "../scss/app.scss";
import "../vendor/globals.js"; // NEED to set first: set window.$, window._, ...
import React from "react";
import { _, moment, Backbone, Marionette, Radio, $, ReactDOM } from "../vendor";
import moment_de from "moment/locale/de";
import moment_fr from "moment/locale/fr";
import moment_en from "moment/locale/en-gb";
import * as Router from "./Router";
import * as Sync from "./Sync";
import { Biscuit } from "./utils";
import User from "./models/User";
import { getContrastTextColor } from "./utils/styles/getLuminace";

import TopBarMenu from "./views/TopBarMenu";
import { appErrorTpl, app404Tpl } from "./views/AppAnnouncements";
import { getEnv, GlobalDebug } from "./Sync";
import { onMessage } from "firebase/messaging";
import { getFirebaseToken, messaging, onMessageListener, usePush } from "./utils/FirebaseConfig";
//import LogRocket from 'logrocket';
import ShowNotification from "./react/helpers/showNotification";
import CheckTime from "./react/components/CheckTime/CheckTime";
import * as FileSaver from "../vendor/FileSaver";
import { S3Client } from "aws_js";
//LogRocket.init('3mm2lq/inbooma');
// Initialize sentry for production system

if (window.__agent) {
  window.__agent.start(Backbone, Marionette);
}

if (window.__backboneAgent) {
  window.__backboneAgent.handleBackbone(Backbone);
}
// Check if the user is on an iOS device
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

// Check for PWA features
const isPWA = "serviceWorker" in navigator && "PushManager" in window;
if ((!isIOS || (isIOS && isPWA)) && usePush) {
  console.log("inside");
  console.log(window.Notification.permission);
  if (window.Notification.permission === "granted") {
    getFirebaseToken().then((firebaseToken) => {
      if (firebaseToken) {
        console.log(firebaseToken, "firebaseToken");
        onMessage(messaging, (payload) => {
          console.log(payload);
        });
      }
    });
  }
}

onMessageListener()
  .then((payload) => {
    if (
      typeof payload.notification !== "undefined" &&
      typeof payload.notification.body !== "undefined" &&
      payload.notification.body !== ""
    ) {
      ShowNotification(null, null, payload.notification.body);
    }
    if (payload.data.data !== "null") {
      const obj = JSON.parse(payload.data.data);
      if (obj?.shouldAlert) {
        alert(payload.notification.body);
      }
      if (typeof obj.name !== "undefined") {
        S3Client.getDocument(Number(Biscuit.get("user.client_id")), "ICS", null, obj.name)
          .then((data) => {
            const blob = new Blob([data.Body], { type: data.ContentType });
            FileSaver.saveAs(blob, obj.name.replace(/_/gi, " "));
          })
          .catch((err) => {
            alert("Could not download: " + err);
          });
      }
      /* let blob;

         if (navigator.userAgent.indexOf('MSIE 10') === -1) { // chrome or firefox
             blob = new Blob([obj.file]);
         } else { // ie - yet untested!
             let bb = new BlobBuilder();
             bb.append(obj.file);
             blob = bb.getBlob('text/x-vCalendar;charset=' + document.characterSet);
         }

         FileSaver.saveAs(blob, + payload.originalMessage + '.ics');*/
    }
  })
  .catch((err) => console.log("failed: ", err));
/*$('#allow-push-notification').click(function () {
    $('.inb-ask-permission').hide();
});
$('#close-push-notification').click(function () {
    $('.inb-ask-permission').hide();
});*/
// Show "page not found" container for invalid routes
const loadUrl = Backbone.History.prototype.loadUrl;

Backbone.History.prototype.loadUrl = function () {
  if (!loadUrl.apply(this, arguments)) {
    const app = Radio.channel("app");
    app.trigger("show:announcement", app404Tpl, "#inb-c");
  }
};

/**
 * Bootstrap the app.
 *
 * In future, most of this should be shifted into an own micro-script
 * that becomes initialized prior to redirecting to App.js
 * There we would check the session token of the user, fetch and set
 * client data and THEN embed App.js
 */

$(document).ready(function () {
  $(document).foundation();
});

const setAppLogo = (logo) => {
  window.requestAnimationFrame(() => {
    document.getElementById("MainLogo1").setAttribute("src", logo);
    document.getElementById("MainLogo2").setAttribute("src", logo);
  });
};

const content_modifications = {
  labels: null,
  hidden_elements: null,
  dashboard: null,
  isReady: false,
};

const getContentModifications = () => {
  return { ...content_modifications };
};

const setContentModifications = (cmods) => {
  if (cmods !== undefined && cmods != null) {
    let cm = JSON.parse(cmods.replace(/'/g, '"'));

    Biscuit.set("client.hasContentModifications", true);

    if (cm.labels !== undefined && cm.labels != null) {
      content_modifications.labels = cm.labels;
    }

    if (cm.hidden_elements !== undefined && cm.hidden_elements != null) {
      content_modifications.hidden_elements = cm.hidden_elements;
    }

    if (cm.dashboard !== undefined && cm.dashboard != null) {
      content_modifications.dashboard = cm.dashboard;
    }
  } else {
    Biscuit.set("client.hasContentModifications", false);
  }
  content_modifications.isReady = true;
  $("body").attr("id", "preset-" + Biscuit.get("user.client_id"));
};

const setClientColors = (response) => {
  const settings = response?.data?.client_settings && response?.data?.client_settings?.[0];
  const primaryColor = response?.data?.primaryColor || (settings && settings?.primaryColor);

  if (primaryColor) {
    Biscuit.set("client.primaryColor", primaryColor, 365);
    document.documentElement.style.setProperty("--inb-primary-color", primaryColor);
    document.documentElement.style.setProperty(
      "--inb-primary-color-contrast-text",
      getContrastTextColor(primaryColor),
    );
  }
};

var clientTariffs = [];

const getClientTariffs = () => {
  return [...clientTariffs];
};

const mapMarker = {
  url: "",
  width: 0,
  height: 0,
  scaleDown: false,
  ready: false,
};

const prepareMarkerImage = () => {
  const clientProduct = Biscuit.get("client.product");

  let markerImage = Biscuit.get("client.marker");
  if (typeof markerImage === "undefined" || markerImage === "" || markerImage === null) {
    if (typeof clientProduct !== "undefined" && clientProduct == "inbooma.net Booking Software") {
      // Default client
      markerImage = "assets/img/default-map-marker.png";
    } else {
      // Bikesharing client
      markerImage = "assets/img/default-map-marker-bikesharing.png";
    }
  }

  // This should only be a temporary solution
  // Actual "problem": On initial page load, LocationsView becomes called too early so client
  // logo & marker is not set yet. Solution: Defer rendering, e.g. via dedicated Radio-event called from App.js
  // or (too be developed) via InboomaBaseView (e.g. this.dependencies = { models: { type: 'client', id: Biscuit.get('user.client_id') } })
  if (Number(Biscuit.get("user.client_id")) === 7) {
    markerImage = "https://s3.eu-central-1.amazonaws.com/inbooma/images/rab_mapmarker.png";
  }

  if (Number(Biscuit.get("user.client_id")) === 11) {
    markerImage = "assets/img/default-map-marker-bikesharing.png";
  }

  const maxSize = 62; // current max dimension of RAB icon
  if (
    !mapMarker.ready &&
    typeof markerImage !== "undefined" &&
    markerImage !== "" &&
    markerImage !== null
  ) {
    mapMarker.ready = true; // prevent multiple loading image
    var img = new Image();
    img.onload = function () {
      let ref = this.width > this.height ? "width" : "height"; // store bigger dimension
      let scale = 1.0; // default: no scale
      mapMarker.url = markerImage; // store image url
      if (this[ref] > maxSize) {
        scale = maxSize / this[ref]; // compute scaling if max size exceeded
        mapMarker.scaleDown = true;
      }
      mapMarker.width = this.width * scale;
      mapMarker.height = this.height * scale;
      //render();
    };
    img.src = markerImage;
  }
};

const settings = Sync.Settings;

const InboomaApp = Marionette.Application.extend({
  region: "#inb-c",

  _user: {}, // @todo Turn into generic user helper

  onStart() {
    const that = this,
      app = Radio.channel("app");

    if (!Biscuit.documentHasCookies() || Biscuit.get("token") == "") {
      /**
       * A first rough is-user-logged-in check was hardcoded into index.hbs
       * @todo BUT we shall find a more restrictive approach (eventually checking
       * for given & valid token before starting app)
       */
      let url = btoa(encodeURI(window.location.href));
      let query = "";
      if (url !== "/login.html") {
        query = "?query=" + url;
      }
      document.location.href = "login.html" + query;

      return false;
    }

    // Apply the client's primary color as CSS variables as early as possible.
    // Biscuit survives reloads; the /clients fetch refreshes these values.
    const storedPrimaryColor = Biscuit.get("client.primaryColor");
    if (storedPrimaryColor) {
      document.documentElement.style.setProperty("--inb-primary-color", storedPrimaryColor);
      document.documentElement.style.setProperty(
        "--inb-primary-color-contrast-text",
        getContrastTextColor(storedPrimaryColor),
      );
    }

    new User({ id: Biscuit.get("user.id") }).fetch({
      success(model, response) {
        model.set(response.data);
        that._user = model;

        // if (initSentry) {
        //     Sentry.configureScope((scope) => {
        //       // Add rudimentary runtime information for Sentry.io
        //       scope.setUser({"id": that._user.get('id')});
        //       scope.setTag("user_role", that._user.get('role'));
        //       scope.setTag("user_lang", that._user.get('lang'));
        //     });
        // }
      },
      error() {
        // Fall back on local data
        that._user = new User({
          id: Biscuit.get("user.id"),
          username: Biscuit.get("user.username"),
          first_name: Biscuit.get("user.first_name"),
          last_name: Biscuit.get("user.last_name"),
          email: Biscuit.get("user.email"),
        });
      },
    });

    // -- @implements Radio.on()
    app.on("show:announcement", (errorMessageHtml = appErrorTpl, targetDiv = "#inb-c-main") => {
      app.trigger("collection:loaded");

      const target = document.querySelector(targetDiv),
        sidebar = document.getElementById("inb-c-sidebar");

      if (!target) return;

      target.innerHTML = "";

      if (sidebar) {
        sidebar.remove();
      }

      target.insertAdjacentHTML("beforeend", errorMessageHtml);
    });

    app.on("change:language", (lang) => {
      Biscuit.set("user.lang", lang, 365);

      that._user.save(
        { lang },
        {
          patch: true,
          success() {
            document.location.reload();
          },
        },
      );
      // @TODO set html lang-attribute for screenreaders
      //Backbone.history.navigate(that._activeView, {trigger: true});
    });

    const overlayCanvas = document.querySelector(".js-off-canvas-overlay"),
      loaderSmall = document.querySelector(".inb-loader--small");

    app.on("destroy:session", (expired_token = false) => {
      // Trigger logout
      const lang = Biscuit.get("user.lang");

      overlayCanvas.classList.add("is-visible");

      Biscuit.deleteAll();

      setTimeout(function () {
        // Prevent async issues in deleteAll() #18860
        // Though solved now as we got rid of cookies
        Biscuit.deleteAll();
        document.location.href = "login.html?lang=" + lang + "#r=" + (expired_token ? "1" : "0");
      }, 700);
    });

    app.on("collection:fetching", () => {
      // Show big loading indicator
      overlayCanvas.classList.add("is-visible");
    });

    app.on("collection:loaded", () => {
      // Hide big loading indicator
      overlayCanvas.classList.remove("is-visible");
    });

    app.on("collection:pagination:start", () => {
      // Show small loading indicator
      loaderSmall.classList.remove("hide");
    });

    app.on("collection:pagination:end", () => {
      // Hide small loading indicator
      loaderSmall.classList.add("hide");
    });

    app.reply("get:active-view", () => {
      return that._activeView;
    });

    app.reply("get:settings", () => {
      return settings;
    });

    app.reply("get:router", (id) => {
      return that._controllers[id];
    });

    app.reply("get:controller", (id) => {
      return that._controllers[id].controller;
    });

    app.reply("get:user", () => {
      return that._user;
    });
    // -- /Radio.on

    const topBarMenu = new TopBarMenu();

    if (getEnv() === "staging") {
      GlobalDebug(false);
    }
    if (getEnv() === "prod") {
      GlobalDebug(false, true);
    }
    if (Biscuit.get("client.logo") !== "" && Biscuit.get("client.logo") !== null) {
      setAppLogo(Biscuit.get("client.logo"));

      // get client settings - required for client specific content modifications
      const ClientSettingsRequest = Backbone.Model.extend({
        urlRoot: "/client_settings/" + Biscuit.get("client.client_settings_id"),
      });

      new ClientSettingsRequest().fetch({
        success(model, response) {
          setContentModifications(response.data.content_modifications);
        },
      });

      const ClientRequest = Backbone.Model.extend({
        urlRoot: "/clients/" + Biscuit.get("user.client_id"),
      });

      new ClientRequest().fetch({
        success(model, response) {
          Biscuit.set("client.id", response.data.id, 365);
          Biscuit.set("client.hash", response.data.hash, 365);
          Biscuit.set("client.user_hash", response.data.user_hash, 365);
          Biscuit.set("client.phone", response.data.phone, 365);
          Biscuit.set("client.canExportSDF", response.data.id == 26, 365);
          Biscuit.set("client.hasGPSLocks", response.data.hasGPSLocks, 365);
          setClientColors(response);
          if (typeof response.data.pricetariffs === typeof []) {
            clientTariffs = [...response.data.pricetariffs];
          }

          const marker = response.data.marker_logo;
          if (response.data.country) {
            /*const country = ct.getCountry(response.data.country);
                        if (country) {
                            moment.tz.setDefault(country.timezones[0]);
                        }*/
          }
          if (marker !== null && marker !== "") {
            Biscuit.set("client.marker", marker, 365);
            prepareMarkerImage(marker);
          }
        },
      });
    } else {
      // Get client's tariff (required for LocationsView)
      const ClientRequest = Backbone.Model.extend({
        urlRoot: "/clients/" + Biscuit.get("user.client_id"),
      });

      new ClientRequest().fetch({
        success(model, response) {
          Biscuit.set("client.id", response.data.id, 365);
          Biscuit.set("client.hash", response.data.hash, 365);
          Biscuit.set("client.user_hash", response.data.user_hash, 365);
          Biscuit.set("client.phone", response.data.phone, 365);
          Biscuit.set("client.canExportSDF", response.data.id == 26, 365);
          Biscuit.set("client.hasGPSLocks", response.data.hasGPSLocks, 365);
          setClientColors(response);
          const logo = response.data.logo,
            marker = response.data.marker_logo;
          Biscuit.set("client.logo", logo);
          if (marker !== null && marker !== "") {
            Biscuit.set("client.marker", marker, 365);
            prepareMarkerImage(marker);
          }

          if (typeof response.data.client_settings !== "undefined") {
            Biscuit.set("client.product", response.data.client_settings[0].product, 365);
            Biscuit.set("client.frontend_url", response.data.client_settings[0].frontend_url);
            Biscuit.set(
              "client.show_usage_types",
              response.data.client_settings[0].show_usage_types,
            );
            Biscuit.set(
              "client.postalVerification",
              response.data.client_settings[0].verify_postal,
            );
            Biscuit.set("client.product", response.data.client_settings[0].product);
            Biscuit.set(
              "client.hasAmountOfContingents",
              response.data.client_settings[0].hasAmountOfContingents,
            );
          }

          if (typeof response.data.pricetariffs === typeof []) {
            clientTariffs = [...response.data.pricetariffs];
          }
          if (response.data.country) {
            /* const country = ct.getCountry(response.data.country);
                        if (country) {
                            moment.tz.setDefault(country.timezones[0]);
                        }*/
          }
          let restypeHandler = {
              isVehicleOwner: false,
              hasAppointments: false,
              isBikeSharing: false,
            },
            restypeCounter = 0,
            resourcetypes = "";

          if (typeof response.data.resourcetypes !== "undefined") {
            _.each(response.data.resourcetypes, (key) => {
              if (resourcetypes === "") {
                resourcetypes = key.name;
              } else {
                resourcetypes += "," + key.name;
              }

              switch (key.id) {
                case 1:
                  restypeHandler.isVehicleOwner = true;
                  restypeCounter++;
                  break;
                case 3:
                  restypeHandler.isBikeSharing = true;
                  restypeCounter++;
                  break;
                case 4:
                  restypeHandler.hasAppointments = true;
                  restypeCounter++;
                  break;
                case 5:
                  restypeHandler.hasParkingLots = true;
                  restypeCounter++;
                  break;
              }
            });
          }
          Biscuit.set(
            "client.currency",
            typeof response.data.currency !== "undefined" ? response.data.currency : "EUR",
          )
            .set(
              "client.country",
              typeof response.data.country !== "undefined" ? response.data.country : "DE",
            )
            .set("client.isVehicleOwner", restypeHandler.isVehicleOwner)
            .set("client.isBikeSharing", restypeHandler.isBikeSharing)
            .set("client.hasAppointments", restypeHandler.hasAppointments)
            .set("client.hasParkingLots", restypeHandler.hasParkingLots)
            .set("client.hasMultipleResourcetypes", restypeCounter > 1)
            .set("client.resourcetypes", resourcetypes)
            .set(
              "client.organization",
              typeof response.data.organization !== "undefined" ? response.data.organization : "",
            )
            .set("client.client_settings_id", response.data.client_settings[0].id)
            .set(
              "client.hasFacilities",
              typeof response.data.facilities !== "undefined" &&
                response.data.facilities.length > 0,
            )
            .set("lock_activated", true) //in_array(response.data.id,[3,12,14,46])
            .set("client.product", response.data.client_settings[0].product)
            .set("client.autoCheckout", response.data.client_settings[0].autoCheckout)
            .set(
              "client.hasAmountOfContingents",
              response.data.client_settings[0].hasAmountOfContingents,
            )
            .set("client.canExportSDF", response.data.id == 26)
            .set(
              "client.showRightOfWithdrawalFields",
              response.data.client_settings[0].showRightOfWithdrawalFields,
            );

          setContentModifications(response.data.client_settings[0].content_modifications);

          if (
            Biscuit.get("client.hasResources") === "true" ||
            Biscuit.get("client.hasResources") === "false"
          ) {
            topBarMenu.render(); // Re-render topBar using the updated user permissions
            $(document).foundation();
          }
          if (logo !== "" && logo !== null) {
            Biscuit.set("client.logo", logo, 365);
            setAppLogo(logo);
          }
        },
      });
      $("body").attr("id", "preset-" + Biscuit.get("user.client_id"));
      // check if client has resources defined (required for top bar menu)
      const ResourceRequest = Backbone.Model.extend({
        urlRoot: "/resources/",
      });

      new ResourceRequest().fetch({
        success(model, response) {
          let hasResources = false;

          if (
            typeof response.data !== "undefined" &&
            response.data.length !== undefined &&
            response.data.length > 0
          ) {
            hasResources = true;
          }
          Biscuit.set("client.hasResources", hasResources);
          if (
            Biscuit.get("client.isVehicleOwner") === "true" ||
            Biscuit.get("client.isVehicleOwner") === "false"
          ) {
            topBarMenu.render(); // Re-render topBar using the updated user permissions
            $(document).foundation();
          }
        },
      });
    }
    switch (settings.language) {
      case "de_DE":
        moment.updateLocale("de", moment_de);
        break;

      case "en_GB":
        moment.updateLocale("en", moment_en);
        break;

      case "fr_FR":
        moment.updateLocale("fr", moment_fr);
        break;

      default:
        moment.updateLocale("de", moment_de);
        break;
    }
    if (Backbone.history) {
      // @TODO push Routers depending on role
      this._controllers = {
        myInboomaRouter: new Router.default.MyInboomaRouter(),
        //dashboardRouter : new Router.default.DashboardRouter(),
        orders: new Router.default.OrdersRouter(),
        // contingents : new Router.default.ContingentsRouter(),
        appointments: new Router.default.AppointmentsRouter(),
        pricediscounts: new Router.default.PricediscountsRouter(),
        //    pricetariffs : new Router.default.PricetariffsRouter(),
        // vouchers : new Router.default.VouchersRouter(),
        reservationsList: new Router.default.ReservationsListRouter(),
        //      sales_billings : new Router.default.SalesBillingsRouter(),
        react: new Router.default.ReactRouter(),
      };

      Backbone.history.start({
        root: "/",
        pushState: true,
      });

      if (Biscuit.get("user.role") === "user") {
        console.log("app navigation ...");
        Backbone.history.navigate("reservations/orders", { trigger: true });
        document.body.classList.remove("view-dashboard"); // Required
      }

      if (Biscuit.get("user.role") === "support") {
        console.log("app navigation ...");
        Backbone.history.navigate("helpdesk", { trigger: true });
        document.body.classList.remove("view-dashboard"); // Required
      }

      /*  if (Biscuit.get('user.client_id') == 26) {
                if (document.location.href.indexOf('dashboard') > 0) {
                    Backbone.history.navigate('reservations/reservationsList', {trigger: true});
                    document.body.classList.remove('view-dashboard'); // Required
                }
            }*/

      // initial navigate to "tasks" if no other valid menu is requested for user role "garage-staff"
      /*         if (Biscuit.get('user.role') == 'garage-staff') {
                if (document.location.href.indexOf('resources') < 0 && document.location.href.indexOf('contingents') < 0 && document.location.href.indexOf('reservationsList') < 0 && document.location.href.indexOf('tasks') < 0) {
                    Backbone.history.navigate('tasks', { trigger:true });
                    document.body.classList.remove('view-dashboard'); // Required
                }
            }
*/

      // Lastly: Catch all click events. If they have a target (href),
      // call the proper router method

      const findDomParent = function (tagname, el) {
        while (el) {
          if ((el.nodeName || el.tagName).toLowerCase() === tagname.toLowerCase()) {
            return el;
          }
          el = el.parentNode;
        }
        return null;
      };

      document.body.onclick = function (e) {
        // Enable "pushState" functionality: Only if the link is valid,
        // we will forward it to the router
        e = e || event;

        let attr = findDomParent("a", e.target || e.srcElement);

        if (attr && !e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey) {
          attr = attr.getAttribute("href");

          if (attr !== "" && typeof attr !== "undefined" && attr !== null) {
            // if backward compatibility for non-HTML5 browsers is required:
            // https://artsy.github.io/blog/2012/06/25/replacing-hashbang-routes-with-pushstate/
            const url = attr.replace(/^\//, "");

            if (url != "#" && !_.isEmpty(url)) {
              if (url.indexOf("http://") >= 0 || url.indexOf("https://") >= 0) {
                window.open(url, "_blank");
                e.preventDefault();
                return;
              }

              e.preventDefault();

              Backbone.history.navigate(url, { trigger: true });
            } else if (url == "#") {
              e.preventDefault();
            }
          }
        }
      };

      // Check if the device time is correct and show a modal if not
      const checkTimeContainer = document.createElement("div");
      document.body.appendChild(checkTimeContainer);
      ReactDOM.render(<CheckTime />, checkTimeContainer);
    }
  },
});
export { getContentModifications, mapMarker, getClientTariffs, setAppLogo };

// ESM-Module are deferred -> DOMContentLoaded is already fired.
function startApp() {
  const inboomaApp = new InboomaApp();
  inboomaApp.start();
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", startApp);
} else {
  startApp();
}
